module.exports = __webpack_public_path__ + "media/images/icn-minus-110e778a87d53c442431db2656eb7834.png";